import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getRentInputFields, housingFundsTypeOptions, ntsTypeOptions } from '../../../common/data';
import { formatNumber } from '../../../common/Util';

import ItemTitleSection from '../../../components/ItemTitleSection';
import TextField from '../../../components/common/TextField';

import Typography from '../../../components/common/Typography';

const Type4 = ({ onOpen }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const ntsTypeList = ntsTypeOptions(tCommon);
  const { s10_3Data } = useSelector(state => state.housingFunds);
  const inputFields = getRentInputFields(t);
  const htm004OptionList = housingFundsTypeOptions(t);

  const renderField = (field, value, endValue = '') => {
    let fieldValue = field.isNumber ? formatNumber(value || '') : value?.trim() || '';
    //국세청구분
    if (field.key === 'htmKFlag') {
      const ntsType = ntsTypeList.find(item => item.value === value);
      fieldValue = ntsType?.label;
    }

    if (field.key === 'htm013' || field.key === 'htm011') {
      fieldValue = fieldValue + (endValue != '' ? ' ~ ' + endValue : '');
    }

    if (field.key === 'htm004') {
      const htm004 = htm004OptionList.find(item => item.value === value);
      fieldValue = htm004?.label;
    }

    return (
      <TextField label={field.label} value={fieldValue} onChange={() => {}} size="small" disabled />
    );
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.title4')}
        addButton={true}
        handleAddButton={() => onOpen('type4', 'detail')}
      />

      {s10_3Data.map((savings, index) => (
        <div key={index} className="savings-item">
          <div className="displayFlexBetween" style={{ marginBottom: '16px' }}>
            <Typography variant="body2Bold">
              {t('detail.title4')}
              {index + 1}
            </Typography>
          </div>

          <div className="displayFlexColumn" style={{ gap: '16px' }}>
            {inputFields.map((field, _index) => (
              <div key={_index}>
                {renderField(field, savings[field.key], savings[field?.endKey])}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Type4;
